import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import VueScrollTo from 'vue-scrollto';
import VueClipboard from 'vue-clipboard2';
import VScrollLock from 'v-scroll-lock';
import clickAway from '~core/plugins/clickaway';

Vue.use(VScrollLock);
Vue.use(VueClipboard);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -50,
});

Vue.use(VueCarousel);
Vue.directive('click-away', clickAway);
